export default "__VITE_PUBLIC_ASSET__844ef61a__"